import React, { useContext } from "react";

import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { ThemeContext } from "styled-components";

import { useStores } from "../../../../contexts/StoreContext";
import CustomSelect from "../../../CustomSelect/CustomSelect";
import Loader from "../../Loader/Loader";

const filterMap = {
  FULL_TIME: "Full Time",
  PART_TIME: "Part Time",
};

function FrontendSelectFilter({ isLoading, type, label }) {
  const { filtersStore } = useStores();

  const { addFromFilter, removeFromFilter, searchBuckets, frontendFilters } =
    filtersStore;
  const theme = useContext(ThemeContext);

  const vacancyCount =
    searchBuckets[type]?.reduce((acc, { name, count }) => {
      acc[name] = count;
      return acc;
    }, {}) || {};
  const handleChange = (vacancyCategories) => {
    const cats = vacancyCategories.map((x) => x.value);
    const added = cats.filter((x) => !frontendFilters[type].includes(x));

    const removed = frontendFilters[type].filter((x) => !cats.includes(x));
    if (added.length > 0) {
      addFromFilter(type, added[0]);
    } else if (removed.length > 0) {
      removed.forEach((x) => removeFromFilter(type, x));
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  const roleSelectStyles = {
    container: (provided) => {
      return {
        ...provided,
        height: "100%",
        width: "100%",
      };
    },
    control: (provided) => ({
      ...provided,
      background: "white",
      borderRadius: "10px",
      boxShadow: "none",
      fontWeight: "400",
      height: "100%",
      textColor: "black",
    }),
    menuList: (provided) => ({
      ...provided,
      padding: "0",
      color: "black",
    }),
    option: (provided) => ({
      ...provided,
      background: theme.primaryBackgroundColor,
      color: "black",
      height: "100%",
    }),
    placeholder: (provided) => ({
      ...provided,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
  };

  const defaultFilters = frontendFilters[type].map((a) => {
    return { label: filterMap[a] || a, value: a };
  });

  return (
    <CustomSelect
      styles={roleSelectStyles}
      defaultValue={defaultFilters}
      id="role"
      isMulti
      onChange={(e) => {
        handleChange(e);
      }}
      options={Object.keys(vacancyCount)?.map((a) => {
        return { label: filterMap[a] || a, value: a };
      })}
      placeholder={label}
    />
  );
}
export default observer(FrontendSelectFilter);

FrontendSelectFilter.propTypes = {
  isLoading: PropTypes.bool,
  label: PropTypes.string,
  type: PropTypes.string,
};

FrontendSelectFilter.defaultProps = {
  isLoading: false,
  label: "Country",
  type: "country",
};
